import { BaseActionProps } from "@/components/common/adCard/types";
import { RiArrowLeftWideLine, RiArrowRightWideLine } from "@remixicon/react";

interface ImageSwitcherActionProps extends BaseActionProps {
  currentIndex: number;
  totalImages: number;
  onPrevious: () => void;
  onNext: () => void;
}

const ImageSwitcherAction = ({
  currentIndex,
  totalImages,
  onPrevious,
  onNext,
}: ImageSwitcherActionProps) => {
  // Don't render if there's only one image or no images
  if (totalImages <= 1) return null;

  const isFirstImage = currentIndex === 0;
  const isLastImage = currentIndex === totalImages - 1;

  return (
    <div className="flex items-center bg-transparent squircle-mask squircle-radius-[8px] squircle-smooth-[1] overflow-hidden">
      {/* Previous Button */}
      <button
        className={`pointer-events-auto text-[12px] font-normal leading-[16px] text-[#fff] flex w-[28px] h-[28px] px-[8px] py-[6px] justify-center items-center gap-[6px] transition-all duration-200 bg-black ${
          isFirstImage
            ? "opacity-40 cursor-not-allowed"
            : "opacity-60 hover:opacity-80 cursor-pointer"
        }`}
        onClick={(e) => {
          e.stopPropagation();
          if (!isFirstImage) onPrevious();
        }}
        disabled={isFirstImage}
      >
        <RiArrowLeftWideLine size={14} className="text-white" />
      </button>

      {/* Next Button */}
      <button
        className={`pointer-events-auto text-[12px] font-normal leading-[16px] text-[#fff] flex w-[28px] h-[28px] px-[8px] py-[6px] justify-center items-center gap-[6px] transition-all duration-200 bg-black ${
          isLastImage
            ? "opacity-40 cursor-not-allowed"
            : "opacity-60 hover:opacity-80 cursor-pointer"
        }`}
        onClick={(e) => {
          e.stopPropagation();
          if (!isLastImage) onNext();
        }}
        disabled={isLastImage}
      >
        <RiArrowRightWideLine size={14} className="text-white" />
      </button>
    </div>
  );
};

export default ImageSwitcherAction;
